import React from 'react';
import GoldButton from '../GoldButton';
import { Label } from '../ui/label';
import { Building2 } from 'lucide-react';

export default function DeliverySection({
  fechaEntrega,
  setShowCalendar,
  coloresSeleccionados,
  concesionarioAsignado,
  setShowConcesionarioModal,
  setShowEmailModal
}) {
  return (
    <div className="bg-[#2A2A2A] border border-white/10 rounded-lg p-6" data-testid="delivery-section">
      <h2 className="font-heading text-xl text-[white] font-semibold mb-4">Asignación de Entrega</h2>
      <div className="space-y-4">
        <div>
          <Label className="text-[white] text-sm font-body uppercase tracking-wider mb-2 block">
            FECHA PROYECTADA PARA ENTREGA
          </Label>
          <button
            type="button"
            onClick={() => setShowCalendar(true)}
            className="w-full bg-[#2A2A2A] border border-white/20 text-white rounded-lg px-4 py-3 text-left hover:border-[#F5A623] transition-colors"
            data-testid="fecha-entrega-button"
          >
            {fechaEntrega ? new Date(fechaEntrega).toLocaleDateString('es-ES', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            }) : 'Seleccionar fecha'}
          </button>
        </div>

        {coloresSeleccionados?.length > 0 && (
          <div>
            <Label className="text-[white] text-sm font-body uppercase tracking-wider mb-2 block">
              Colores Seleccionados por el Cliente
            </Label>
            <div className="flex flex-wrap gap-2">
              {coloresSeleccionados.map((color, idx) => (
                <span 
                  key={idx} 
                  className="px-3 py-1 bg-[#F5A623]/20 text-[#F5A623] border border-[#F5A623]/30 rounded-full text-xs font-body"
                >
                  {color}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Mostrar Concesionario Asignado */}
        {concesionarioAsignado && (
          <div>
            <Label className="text-[white] text-sm font-body uppercase tracking-wider mb-2 block">
              Concesionario Asignado
            </Label>
            <div className="bg-[#1A1A1A] border border-[#10B981]/30 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <div className="p-2 bg-[#10B981]/20 rounded-lg">
                  <Building2 className="w-5 h-5 text-[#10B981]" />
                </div>
                <div className="flex-1">
                  <p className="text-white font-semibold">{concesionarioAsignado.nombre}</p>
                  {concesionarioAsignado.ciudad && (
                    <p className="text-[#666666] text-sm mt-1">📍 {concesionarioAsignado.ciudad}</p>
                  )}
                  {concesionarioAsignado.telefono && (
                    <p className="text-[#666666] text-sm">📞 {concesionarioAsignado.telefono}</p>
                  )}
                  {concesionarioAsignado.direccion && (
                    <p className="text-[#666666] text-sm">📧 {concesionarioAsignado.direccion}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="pt-6 border-t border-white/10 space-y-3">
          <GoldButton
            onClick={() => setShowConcesionarioModal(true)}
            variant="secondary"
            className="w-full bg-[#3B82F6]/20 text-[#3B82F6] border-[#3B82F6]/30 hover:bg-[#3B82F6]/30"
          >
            🏢 {concesionarioAsignado ? 'Cambiar Concesionario' : 'Asignar Concesionario'}
          </GoldButton>
          
          <GoldButton
            onClick={() => setShowEmailModal(true)}
            variant="primary"
            className="w-full"
          >
            📧 Centro de Comunicaciones
          </GoldButton>
        </div>
      </div>
    </div>
  );
}
